module.exports = require("vue-moment");